import { X, HardHat, ArrowUpRight, ImageOff } from 'lucide-react';
import { useState } from 'react';

import {
  etykietaCeny,
  opisMetrologii,
  zdjeciaOferty,
  type UrzadzenieOferty,
} from '../../lib/marketplaceDevices';

/**
 * Karta szczegolow oferty sprzetowej (487).
 *
 * DLACZEGO OSOBNY EKRAN, A NIE DLUZSZA KAFELKA: specyfikacja wagi to
 * kilkanascie wierszy — wykonanie, grupa metrologiczna, usluga po usludze
 * z cennika §6.4 — a czujnika jeszcze wiecej. Na kafelce w siatce trzech
 * kolumn nie ma na to miejsca i konczy sie to obcieciem opisu w polowie
 * zdania o tym, czego urzadzenie NIE robi. Akurat to zdanie musi byc cale.
 *
 * Modal NICZEGO nie liczy i niczego nie sklada z liczb: metrologia przychodzi
 * ze zlaczenia z rejestrem modeli, cena z kolumn oferty, a `long_description`
 * jest tekstem z bazy. Ekran jest tu wylacznie szyba.
 */
export function UrzadzenieSzczegoly({
  urzadzenie,
  onClose,
}: {
  urzadzenie: UrzadzenieOferty;
  onClose: () => void;
}) {
  const cena = etykietaCeny(urzadzenie);
  const metrologia = opisMetrologii(urzadzenie.fabrica_instrument_models);
  const kod = urzadzenie.fabrica_instrument_models?.code;
  const zdjecia = zdjeciaOferty(urzadzenie);

  // Zdjecie katalogowe mieszka poza nasza domena. Gdy nie dojdzie, karta ma
  // pokazac brak obrazka, a nie ikone zepsutego pliku obok ceny za 21 tys.
  const [zdjecieDoszlo, setZdjecieDoszlo] = useState(true);

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60"
      onClick={onClose}
    >
      <div
        className="bg-gray-800 rounded-ids-xl border border-gray-700 w-full max-w-3xl max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sticky top-0 bg-gray-800 border-b border-gray-700 px-6 py-4 flex items-start justify-between gap-4">
          <div className="flex items-center gap-3 min-w-0">
            <div className="w-10 h-10 rounded-ids-md bg-amber-500/20 border border-amber-500/30 flex items-center justify-center shrink-0">
              <HardHat className="w-5 h-5 text-amber-400" />
            </div>
            <div className="min-w-0">
              <h3 className="text-lg font-semibold text-aurora-text truncate">{urzadzenie.name}</h3>
              {metrologia && <p className="text-sm text-amber-300/90">{metrologia}</p>}
            </div>
          </div>
          <button
            onClick={onClose}
            aria-label="Zamknij"
            className="p-1 text-gray-400 hover:text-aurora-text transition-colors shrink-0"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-6 space-y-5">
          {zdjecia.length > 0 && (
            <div className="rounded-ids-lg border border-gray-700 bg-gray-900/40 overflow-hidden flex items-center justify-center min-h-[8rem]">
              {zdjecieDoszlo ? (
                <img
                  src={zdjecia[0]}
                  alt={urzadzenie.name}
                  loading="lazy"
                  referrerPolicy="no-referrer"
                  onError={() => setZdjecieDoszlo(false)}
                  className="max-h-72 w-auto object-contain"
                />
              ) : (
                <div className="flex items-center gap-2 text-gray-500 text-sm py-10">
                  <ImageOff className="w-5 h-5" />
                  Zdjęcie katalogowe niedostępne
                </div>
              )}
            </div>
          )}

          <div className="flex flex-wrap items-center gap-2">
            {kod && (
              <span className="text-xs font-mono text-gray-300 bg-gray-900/60 border border-gray-700 rounded px-2 py-1">
                {kod}
              </span>
            )}
            <span className="text-xs text-gray-400 bg-gray-900/60 border border-gray-700 rounded px-2 py-1">
              {urzadzenie.slug}
            </span>
          </div>

          {urzadzenie.short_description && (
            <p className="text-gray-300">{urzadzenie.short_description}</p>
          )}

          {urzadzenie.long_description && (
            <div className="rounded-ids-lg border border-gray-700 bg-gray-900/30 p-4">
              <p className="text-sm text-gray-300 whitespace-pre-line leading-relaxed">
                {urzadzenie.long_description}
              </p>
            </div>
          )}

          <div className="rounded-ids-lg border border-gray-700 bg-gray-900/30 p-4 flex flex-wrap items-end justify-between gap-4">
            <div>
              <div
                className={`text-xl font-semibold ${
                  cena.naZapytanie ? 'text-gray-300' : 'text-aurora-text'
                }`}
              >
                {cena.tekst}
              </div>
              {cena.brutto && <div className="text-sm text-gray-400 mt-0.5">{cena.brutto}</div>}
              {urzadzenie.lead_time_days && (
                <div className="text-xs text-gray-500 mt-1">
                  Dostawa ok. {urzadzenie.lead_time_days} dni
                </div>
              )}
            </div>

            {/* Zapytanie mailem, a nie koszyk — sciezka platnosci za sprzet nadal
                nie istnieje, wiec przycisk „Kup" obiecywalby transakcje, ktorej
                nie ma (`391`). Cena na metce tego nie zmienia. */}
            <a
              href={`mailto:kontakt@insolitum.ai?subject=${encodeURIComponent(
                `Zamówienie / wycena: ${urzadzenie.name}${kod ? ` (${kod})` : ''}`
              )}`}
              className="flex items-center gap-1.5 px-4 py-2.5 rounded-ids-md bg-amber-500/20 border border-amber-500/30 text-amber-300 text-sm font-medium hover:bg-amber-500/30 transition-colors"
            >
              Zapytaj o dostępność
              <ArrowUpRight className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
